__turbopack_context__.v({
  "daymadeDifference": "PrizePage-module__yp1cWW__daymadeDifference",
  "daymadeDifferenceEmoji": "PrizePage-module__yp1cWW__daymadeDifferenceEmoji",
  "li": "PrizePage-module__yp1cWW__li",
  "winnerCarouselContainer": "PrizePage-module__yp1cWW__winnerCarouselContainer",
});
